import React, { useEffect, useState } from 'react'

const MemberAccess = () => {
  const [memberStatus, setMemberStatus] = useState();

  const getCookie = (cname) => {
    // console.log("Cookie..." + cname);
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  const checkCookie = (cname) => {
    var cookieValue = getCookie(cname);
    if (cookieValue !== "") {
      // Member is signed in
      setMemberStatus(true);
    } else {
      // Member is not signed in
      setMemberStatus(false);
    }
  };

  useEffect (() => {
    // Check if "token" exists in the cookie
    checkCookie("token");
  });

  // ***** Used for testing Sign in functionality without actually hitting the CRM *****
  
  // const addToken = () => {
  //   console.log("addToken called");
  //   document.cookie = "token=Here is a token; path=/;";
  //   setMemberStatus(true);
  // }
  // const removeToken = () => {
  //   console.log("removeToken called");
  //   document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //   setMemberStatus(false);
  // }

  const MenuItem = (props) => {
    return (
      <a className="py-1 px-0 lg:px-2 text-gray-200 font-display lg:font-sans text-lg lg:text-base rounded hover:bg-opacity-20 hover:bg-white hover:text-wt-blue-highlight" href={ props.url }>
        { props.text }
      </a>
    )
  }

  const DisplayHTML = () => {
    if (memberStatus) {
      // Member is signed in, display Dashboard & Sign out
      return (
        <React.Fragment>
          {/* <a className="py-1 px-2 text-gray-200 rounded hover:bg-opacity-20 hover:bg-white hover:text-wt-blue-highlight" href="/dashboard">
            Dashboard
          </a>
          <a className="py-1 px-2 text-gray-200 rounded hover:bg-opacity-20 hover:bg-white hover:text-wt-blue-highlight" href="/logout.php">
            Sign out
          </a> */}
          <MenuItem text="Dashboard" url="/dashboard/" />
          <MenuItem text="Sign out" url="/logout.php" />
        </React.Fragment>
      )
    } else {
      // Member is not signed in, display Sign in
      return (
        <React.Fragment>
          {/* <a className="py-1 px-2 text-gray-200 rounded hover:bg-opacity-20 hover:bg-white hover:text-wt-blue-highlight" href="/login-member/">
            Sign in
          </a> */}
          <MenuItem text="Sign in" url="/login-member/" />
        </React.Fragment>
      )
    }
  }

  return (
    <React.Fragment>
      <div className="hidden lg:flex w-full items-center Xlg:border-b Xlg:border-wt-blue-gray Xlg:border-opacity-50 mt-4 mb-1">
        {/* <span className="icon">
          <i className="text-wt-blue-gray pr-2 fas fa-user-check"></i>
        </span> */}
        <span className="text-lg lg:text-xl font-display font-light text-wt-blue-gray">Member Access</span>
      </div>
      {/* <button className="navbar-item is-transparent is-borderless" onClick={() => addToken()}>
        Add token to cookie
      </button>
      <button className="navbar-item is-transparent is-borderless" onClick={() => removeToken()}>
        Remove token from cookie
      </button> */}
      <div className="flex flex-col w-full border-l-0 lg:border-l-2 lg:border-wt-blue-gray lg:border-opacity-25 lg:pl-1">
        <DisplayHTML />
      </div>
    </React.Fragment>
  )
};

export default MemberAccess;